export default {
    impression : 'توضیحات پزشک',
    ddx : 'ddx',
    maleFactor : 'عامل مردانه',
    femaleFactor : 'عامل زنانه',
    prescription : 'دارو',
    clinicSonographies : 'سونوگرافی‌های کلینیک',
    drugName : 'نام دارو',
    dosageOfTheDrug : 'دوز دارو',
    durationOfMedication : 'مدت مصرف',
    count : 'تعداد',
    medicationHours : 'ساعت ',
    date : 'تاریخ',
    referDate : 'تاریخ ارجاع',
    description : 'توضیحات',
    sonographyAndLab : 'سونوگرافی و آزمایش',
    plan : 'طرح/برنامه',
    artType : 'نوع ART',
    urology : 'اورولوژی',
    genetic : 'ژنتیک',
    pgd : 'PGD',
    pgs : 'PGS',
    generalSurgery  : 'جراحی عمومی',
    surgeryType  : 'نوع جراحی',
    surgery  : ' جراحی',
    time  : 'ساعت',
    midwife  : 'ماما',
    dr  : 'دکتر',
    clinicSonographyType  : 'نوع سونوگرافی',
    referType  : 'نوع ارجاع',
    referRole  : 'نام پزشک',
    referDescription  : 'توضیحات',
    print  : 'چاپ',
    nextAppointment  : 'ویزیت بعدی',
    complaintAndAssessment  : 'ارزیابی',
    referenceTo  : 'ارجاعات',
    nextVisit  : 'ویزیت بعدی',
    visitDate  : 'تاریخ ویزیت',
    showVisitItems  : 'نمایش جزئیات ویزیت',
    pgdReason  : 'دلیل PGD',
    genderType  : 'جنسیت',
    antenatalCareTests  : 'مراقبتهای قبل زایمان',
    fileTo  : 'ارجاع به',
    reasonOfReference  : 'نظرات پزشکان (ورودی ارجاعات)',
    reasonOfReferenceField  : 'علت ارجاعات',
    specialty  : 'تخصص',
    fromDoctorUser  : 'پزشک ارجاع دهنده',
    fileFrom: 'ارجاع از',
    referenceFor: 'ثبت ارجاع برای',
}
